/* eslint-disable */
import React from 'react';
import { Paper, Box, useMediaQuery, useTheme } from '@mui/material';
import { differenceInCalendarMonths } from 'date-fns';
import Month from './customWeek';
import DefinedRanges from './definedPresetRanges';
import { MARKERS } from './dateRangePicker';
import PropTypes from 'prop-types';
import './customDateRange.scss';

const Menu = ({
  ranges,
  dateRange,
  minDate,
  maxDate,
  firstMonth,
  setFirstMonth,
  secondMonth,
  setSecondMonth,
  setDateRange,
  helpers,
  handlers,
  onCustomSelect,
  useCurrentYear,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const canNavigateCloser = differenceInCalendarMonths(secondMonth, firstMonth) >= 2;
  const commonProps = { dateRange, minDate, maxDate, helpers, handlers };
  const defaultRange = ranges.find(range => range.label === 'Last 2 Months');
  const selectedRange = dateRange || defaultRange;

  return (
    <Paper elevation={5} square>
      <Box
        display="flex"
        flexDirection={isSmallScreen ? 'column' : 'row'}
        flexWrap="nowrap"
      >
        <Box
          flexGrow={1}
          display="flex"
          flexDirection={isSmallScreen ? 'column' : 'row'}
          flexWrap="nowrap"
          mb={isSmallScreen ? 2 : 0}
        >
          <Month
            {...commonProps}
            value={firstMonth}
            setValue={setFirstMonth}
            navState={[true, canNavigateCloser]}
            marker={MARKERS.FIRST_MONTH}
            useCurrentYear={useCurrentYear}
          />
          <div />
          <Month
            {...commonProps}
            value={secondMonth}
            setValue={setSecondMonth}
            navState={[canNavigateCloser, true]}
            marker={MARKERS.SECOND_MONTH}
            useCurrentYear={useCurrentYear}
          />
        </Box>

        <Box
          display={isSmallScreen ? 'block' : 'flex'}
          flexGrow={1}
          mb={isSmallScreen ? 2 : 0}
          mr={isSmallScreen ? 1 : 2}
        >
          <DefinedRanges
           selectedRange={selectedRange}
            ranges={ranges}
            setRange={setDateRange}
            onCustomSelect={onCustomSelect}
          />
        </Box>
      </Box>

    </Paper>
  );
};

Menu.propTypes = {
  ranges: PropTypes.arrayOf(
    PropTypes.shape({
      startDate: PropTypes.instanceOf(Date),
      endDate: PropTypes.instanceOf(Date),
      label: PropTypes.string,
    }),
  ).isRequired,
  dateRange: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  }).isRequired,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  firstMonth: PropTypes.instanceOf(Date).isRequired,
  setFirstMonth: PropTypes.func.isRequired,
  secondMonth: PropTypes.instanceOf(Date).isRequired,
  setSecondMonth: PropTypes.func.isRequired,
  setDateRange: PropTypes.func.isRequired,
  helpers: PropTypes.object,
  handlers: PropTypes.object,
 onCustomSelect: PropTypes.func,
 useCurrentYear: PropTypes.bool,
};

export default Menu;
